import { render } from "./Create.vue?vue&type=template&id=25949965&bindings={\"isModalOpen\":\"setup\",\"submit\":\"setup\",\"state\":\"setup\"}"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
script.render = render

export default script